<ng-container *ngTemplateOutlet="currentTemplate; context: context"></ng-container>

<ng-template #template_default let-title="title">
<div style="page-break-inside: avoid">
    <h5>{{ title }}</h5>
    <table class="optionalComponentSectionTable">
        <tr style="font-weight: bold;">
            <td>Axis Type</td>
            <td style="text-align:right;padding-right:5px;">No. of Turbines</td>
            <td style="text-align:right;padding-right:5px;">Height (m)</td>
            <td style="text-align:right;padding-right:5px;">Hub Height (m)</td>
            <td style="text-align:right;padding-right:5px;">Blade Length (m)</td>
            <td style="text-align:right;padding-right:5px;">Device Capacity (MW)</td>
            <td *ngIf="areAnyWindTurbinesOffshore()">Foundation Type</td>
            <td>Manufacturer</td>
        </tr>

        <tr *ngFor="let pwt of windTurbines">
            <td><span [innerHTML]="pwt.windTurbineType | highlight: searchTerm"></span></td>

            <td *ngIf="pwt.exactNumberOfTurbines" style="text-align:right;padding-right:5px;">
                {{pwt.exactNumberOfTurbines}}
            </td>

            <td *ngIf="!pwt.exactNumberOfTurbines" style="text-align:right;padding-right:5px;">
            
                <!-- More than X -->
                <span *ngIf="pwt.minNumberOfTurbines > 0 && !pwt.maxNumberOfTurbines">
                    more than {{pwt.minNumberOfTurbines}}
                </span>
            
                <!-- X - Y -->
                <span *ngIf="pwt.minNumberOfTurbines > 0 && pwt.maxNumberOfTurbines > 0">
                    {{pwt.minNumberOfTurbines}} - {{pwt.maxNumberOfTurbines}}
                </span>
            
                <!-- Up to Y -->
                <span *ngIf="(!pwt.minNumberOfTurbines || pwt.minNumberOfTurbines <= 0) && pwt.maxNumberOfTurbines > 0">
                    up to {{pwt.maxNumberOfTurbines}}
                </span>
            
            </td>      
            
            <!-- <td style="text-align:right;padding-right:5px;">
                <span *ngIf="pwt.minNumberOfTurbines && !pwt.exactNumberOfTurbines && !pwt.maxNumberOfTurbines">more
                    than</span>
                <span>{{ pwt.minNumberOfTurbines }}</span>
                <span *ngIf="pwt.minNumberOfTurbines && !pwt.exactNumberOfTurbines && pwt.maxNumberOfTurbines"> -
                </span>
                <span *ngIf="!pwt.minNumberOfTurbines && !pwt.exactNumberOfTurbines && pwt.maxNumberOfTurbines">up to
                </span>
                <span>{{ pwt.maxNumberOfTurbines }}</span>
                <span *ngIf="pwt.exactNumberOfTurbines">{{ pwt.exactNumberOfTurbines }}</span>
            </td> -->

            <td style="text-align:right;padding-right:5px;">{{ pwt.height }}</td>
            <td style="text-align:right;padding-right:5px;">{{ pwt.hubHeight }}</td>
            <td style="text-align:right;padding-right:5px;">{{ pwt.bladeLength }}</td>
            <td style="text-align:right;padding-right:5px;">
                {{ pwt.deviceCapacity }}
            </td>
            <td *ngIf="areAnyWindTurbinesOffshore()">
                {{ pwt.offshoreWindFoundationType }}
            </td>
            <td>{{ pwt.manufacturer }}</td>
        </tr>
    </table>
</div>
</ng-template>

<ng-template #template_mobile let-title="title">
<div style="page-break-inside: avoid">
    <h5>{{ title }}</h5>
    <div class="optionalComponentSectionTable" *ngFor="let pwt of windTurbines">
        <div>
            <span style="font-weight:bold">Axis Type: </span>
            <span [innerHTML]="pwt.windTurbineType | highlight: searchTerm"></span>
        </div>
        <div>
            <span style="font-weight:bold">No. of Turbines: </span>
            <span *ngIf="pwt.minNumberOfTurbines && !pwt.exactNumberOfTurbines && !pwt.maxNumberOfTurbines">more
                than</span>
            <span>{{ pwt.minNumberOfTurbines }}</span>
            <span *ngIf="pwt.minNumberOfTurbines && !pwt.exactNumberOfTurbines && pwt.maxNumberOfTurbines"> - </span>
            <span *ngIf="!pwt.minNumberOfTurbines && !pwt.exactNumberOfTurbines && pwt.maxNumberOfTurbines">up to
            </span>
            <span>{{ pwt.maxNumberOfTurbines }}</span>
            <span *ngIf="pwt.exactNumberOfTurbines">{{ pwt.exactNumberOfTurbines }}</span>
        </div>
        <div *ngIf="pwt.height && pwt.height !== 0">
            <span style="font-weight:bold">Height (m): </span>
            <span>{{ pwt.height }}</span>
        </div>
        <div *ngIf="pwt.hubHeight && pwt.hubHeight !== 0">
            <span style="font-weight:bold">Hub Height (m): </span>
            <span>{{ pwt.hubHeight }}</span>
        </div>
        <div *ngIf="pwt.bladeLength && pwt.bladeLength !== 0">
            <span style="font-weight:bold">Blade Length (m): </span>
            <span>{{ pwt.bladeLength }}</span>
        </div>
        <div *ngIf="pwt.deviceCapacity && pwt.deviceCapacity !== 0">
            <span style="font-weight:bold">Device Capacity (MW): </span>
            <span>{{ pwt.deviceCapacity }}</span>
        </div>
        <div *ngIf="areAnyWindTurbinesOffshore()">
            <span style="font-weight:bold">Foundation: </span>
            <span>{{ pwt.offshoreWindFoundationType }}</span>
        </div>
        <div *ngIf="pwt.manufacturer">
            <span style="font-weight:bold">Manufacturer: </span>
            <span>{{ pwt.manufacturer }}</span>
        </div>
    </div>
</div>
</ng-template>